import React, { useState, useEffect } from 'react';
import SitemapService from '../utils/sitemap';
import { publicAPI } from '../services/api';

const SitemapXML = () => {
  const [sitemapXml, setSitemapXml] = useState('Loading...');

  useEffect(() => {
    const generateSitemap = async () => {
      try {
        // Fetch TCG data
        const response = await publicAPI.getEndpoints();
        let supportedTcgs = [];

        if (response.data.success) {
          supportedTcgs = response.data.data.supported_tcgs || [];
        }

        // Generate sitemap with TCG data
        const xml = await SitemapService.generateSitemap(window.location.origin, supportedTcgs);
        setSitemapXml(xml);
      } catch (error) {
        console.error('Error generating sitemap:', error);
        // Fallback to basic sitemap without TCG data
        try {
          const xml = await SitemapService.generateSitemap();
          setSitemapXml(xml);
        } catch (fallbackError) {
          setSitemapXml('Error generating sitemap');
        }
      }
    };

    generateSitemap();
  }, []);

  return (
    <pre style={{
      margin: 0,
      padding: 0,
      fontFamily: 'monospace',
      whiteSpace: 'pre-wrap',
      fontSize: '12px'
    }}>
      {sitemapXml}
    </pre>
  );
};

export default SitemapXML;